(function () {
	/* --- Filtering -------------------------------------------------------- */
	function applyFilter(filter) {
		const cards = document.querySelectorAll('.gallery-card');
		const filterButtons = document.querySelectorAll('.gallery-filter-item');
		const value = filter ? filter.toLowerCase() : 'all';

		filterButtons.forEach((button) => {
			button.classList.toggle(
				'gallery-filter-item--active',
				button.dataset.filter === value
			);
		});

		cards.forEach((card) => {
			const matches = value === 'all' || card.dataset.filter === value;
			card.classList.toggle('gallery-card-hidden', !matches);
		});

		const url = new URL(window.location);
		if (value && value !== 'all') {
			url.searchParams.set('filter', value);
		} else {
			url.searchParams.delete('filter');
		}
		window.history.replaceState({}, '', url);
	}

	/* --- Lightbox -------------------------------------------------------- */
	let lightbox = null;
	let lightboxKeydown = null;
	// Slides are rebuilt on every open so the arrows only ever walk through the
	// artworks currently visible under the active filter.
	let slides = [];
	let slideIndex = -1;

	function collectSlides() {
		slides = Array.prototype.filter.call(
			document.querySelectorAll('.gallery-card__img-wrapper[data-zoom]'),
			(wrap) => {
				const card = wrap.closest('.gallery-card');
				return !card || !card.classList.contains('gallery-card-hidden');
			}
		);
	}

	function showSlide(index) {
		// The gallery does not loop: the ends of the list are hard stops.
		if (index < 0 || index >= slides.length) return;
		slideIndex = index;
		const wrap = slides[slideIndex];
		renderLightbox(wrap.dataset.zoomSrc, wrap.dataset.zoomTitle);
	}

	function step(delta) {
		showSlide(slideIndex + delta);
	}

	function buildLightbox() {
		if (lightbox) return lightbox;

		const lb = document.createElement('div');
		lb.className = 'gallery-lightbox';
		lb.setAttribute('hidden', '');
		lb.setAttribute('role', 'dialog');
		lb.setAttribute('aria-modal', 'true');
		lb.innerHTML =
			'<button type="button" class="gallery-lightbox__close" data-lightbox-close aria-label="Close">' +
				'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
			'</button>' +
			'<figure class="gallery-lightbox__fig">' +
				'<div class="gallery-lightbox__stage">' +
					'<img class="gallery-lightbox__img" data-lightbox-img src="" alt="">' +
					'<button type="button" class="gallery-lightbox__nav gallery-lightbox__nav--prev" data-lightbox-prev aria-label="Previous image">' +
						'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
					'</button>' +
					'<button type="button" class="gallery-lightbox__nav gallery-lightbox__nav--next" data-lightbox-next aria-label="Next image">' +
						'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
					'</button>' +
				'</div>' +
				'<figcaption class="gallery-lightbox__caption" data-lightbox-caption></figcaption>' +
			'</figure>';
		document.body.appendChild(lb);
		lightbox = lb;

		lb.addEventListener('click', (e) => {
			if (e.target.closest('[data-lightbox-prev]')) {
				step(-1);
				return;
			}
			if (e.target.closest('[data-lightbox-next]')) {
				step(1);
				return;
			}
			if (e.target === lb || e.target.closest('[data-lightbox-close]')) {
				closeLightbox();
			}
		});
		lightboxKeydown = (e) => {
			if (e.key === 'Escape') closeLightbox();
			else if (e.key === 'ArrowLeft') step(-1);
			else if (e.key === 'ArrowRight') step(1);
		};

		return lb;
	}

	// Swaps the image/caption in an already-open lightbox.
	function renderLightbox(src, title) {
		const lb = buildLightbox();
		const img = lb.querySelector('[data-lightbox-img]');
		const cap = lb.querySelector('[data-lightbox-caption]');
		img.src = src;
		img.alt = title || '';
		if (cap) {
			cap.textContent = title || '';
			cap.style.display = title ? '' : 'none';
		}
		// A single artwork (or a filter that leaves one) has nothing to page to,
		// and at either end of the list the arrow pointing past it is disabled.
		const multiple = slides.length > 1;
		const prev = lb.querySelector('[data-lightbox-prev]');
		const next = lb.querySelector('[data-lightbox-next]');
		if (prev) {
			prev.hidden = !multiple;
			prev.disabled = slideIndex <= 0;
		}
		if (next) {
			next.hidden = !multiple;
			next.disabled = slideIndex >= slides.length - 1;
		}
		return lb;
	}

	function openLightbox(src, title) {
		if (!src) return;
		const lb = renderLightbox(src, title);
		lb.removeAttribute('hidden');
		document.body.classList.add('gallery-lightbox-open');
		document.addEventListener('keydown', lightboxKeydown);
		const closeBtn = lb.querySelector('[data-lightbox-close]');
		if (closeBtn) closeBtn.focus();
	}

	function closeLightbox() {
		if (!lightbox) return;
		lightbox.setAttribute('hidden', '');
		document.body.classList.remove('gallery-lightbox-open');
		document.removeEventListener('keydown', lightboxKeydown);
		const img = lightbox.querySelector('[data-lightbox-img]');
		if (img) img.src = '';
	}

	/* --- Copy link ------------------------------------------------------- */
	// Shopify's image_url returns protocol-relative URLs (//cdn.shopify.com/...)
	// which work as <img src> but not when pasted into an address bar. Resolve
	// them to an absolute https:// URL.
	function toAbsolute(url) {
		if (!url) return url;
		try {
			return new URL(url, window.location.href).href;
		} catch (err) {
			return url;
		}
	}

	function copyText(text) {
		if (navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(text);
		}
		return new Promise((resolve, reject) => {
			try {
				const ta = document.createElement('textarea');
				ta.value = text;
				ta.setAttribute('readonly', '');
				ta.style.position = 'absolute';
				ta.style.left = '-9999px';
				document.body.appendChild(ta);
				ta.select();
				document.execCommand('copy');
				document.body.removeChild(ta);
				resolve();
			} catch (err) {
				reject(err);
			}
		});
	}

	function flashCopied(btn) {
		btn.classList.add('is-copied');
		const label = btn.querySelector('[data-copy-label]');
		const prev = label ? label.textContent : null;
		if (label) label.textContent = 'Copied!';
		clearTimeout(btn._copyTimer);
		btn._copyTimer = setTimeout(() => {
			btn.classList.remove('is-copied');
			if (label && prev != null) label.textContent = prev;
		}, 1600);
	}

	/* --- Card interactions ---------------------------------------------- */
	function zoom(wrap) {
		collectSlides();
		slideIndex = slides.indexOf(wrap);
		openLightbox(wrap.dataset.zoomSrc, wrap.dataset.zoomTitle);
	}

	function initCards() {
		document
			.querySelectorAll('.gallery-card__img-wrapper[data-zoom]')
			.forEach((wrap) => {
				wrap.addEventListener('click', (e) => {
					if (e.target.closest('[data-copy-link]')) return;
					zoom(wrap);
				});

				wrap.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						zoom(wrap);
					}
				});

				const copyBtn = wrap.querySelector('[data-copy-link]');
				const imageUrl = toAbsolute(wrap.dataset.zoomSrc);
				if (copyBtn && imageUrl) {
					copyBtn.addEventListener('click', (e) => {
						e.stopPropagation();
						copyText(imageUrl)
							.then(() => flashCopied(copyBtn))
							.catch(() => {});
					});
				}
			});
	}

	/* --- Init ------------------------------------------------------------ */
	function init() {
		const filterEl = document.querySelector('[data-gallery-filter]');
		if (filterEl) {
			filterEl.querySelectorAll('.gallery-filter-item').forEach((btn) => {
				btn.addEventListener('click', function () {
					applyFilter(this.dataset.filter);
				});
			});

			const params = new URLSearchParams(window.location.search);
			const initial = params.get('filter');
			const known =
				initial &&
				filterEl.querySelector(
					'.gallery-filter-item[data-filter="' +
						initial.toLowerCase() +
						'"]'
				);

			applyFilter(known ? initial : 'all');
		}

		initCards();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
